function r(r){if(null===r||!0===r||!1===r)return NaN;var a=Number(r);return isNaN(a)?a:a<0?Math.ceil(a):Math.floor(a)}export{r as default};
